<template v-slot:LandingPage>
  <div class="volumes-abo-option">
    <div class="volumes__sorting-btn">
      <button :class="isBestPriceSorted ? 'active': ''" @click="isBestPriceSorted = true">Bester Preis</button>
      <button :class="!isBestPriceSorted ? 'active': ''" @click="isBestPriceSorted = false">Mehr GB</button>
    </div>
    <ol :class="{ promoBadge: getPromotionsForOption(selectableAboOptionKeys).length > 0 }">
      <template v-if="selectableAboOptions && selectableAboOptions.length">
        <AboOptionVersionB v-bind="selectableAboOption" v-for="(selectableAboOption, index) in selectableAboOptions" :key="index"
          :promoPrice="promoPrice"
          :normalPrice="normalPrice"
          :targetTariff="targetTariff"
          :defaultTxtProductHighlights="defaultTxtProductHighlights"
          :defaultInfoModalHighlights="defaultInfoModalHighlights"
          :lblMoreInfoButton="lblMoreInfoButton"
          :areaLabelMoreInfo="areaLabelMoreInfo"
          :lblOrderButton="lblOrderButton"
          :txtLegalTerms="txtLegalTerms"
          :txtInfoIconAlt="txtInfoIconAlt"
          :lblAriaLabelCTA="lblAriaLabelCTA"
          :pricePromoColor="pricePromoColor"
          :priceColor="priceColor"
          :txtPriceCurrency="txtPriceCurrency"
          :targetPromotions="targetPromotions"
        ></AboOptionVersionB>
      </template>
    </ol>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import useFeature from '@/mixins/useFeature'
import price from '@/mixins/formatters/price'
import date from '@/mixins/validators/date'
import AboOptionVersionB from './AboOptionVersionB.vue'

export default {
  name: 'VolumesAboOptionVersionB',
  data () {
    return {
      selectedOption: 'none',
      isBestPriceSorted: true,
      isOption130: false
    }
  },
  components: {
    AboOptionVersionB
  },
  mounted () {
    this.prefillSelectedOption()
  },
  mixins: [
    price,
    date,
    useFeature('birthdayPromo'),
    useFeature('preSelectOption130')
  ],
  props: {
    targetTariff: {
      type: Object,
      default: null
    },
    availableAboOptions: {
      type: Array,
      default: () => []
    },
    volumePromotions: {
      type: Array,
      default: () => []
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    process: {
      type: String,
      default: 'ordering'
    },
    targetPromotions: {
      type: Array,
      default: () => []
    },
    excludePromotionIds: {
      type: Array,
      default: () => []
    },
    normalPrice: {
      type: Object,
      default: null
    },
    promoPrice: {
      type: Object,
      default: null
    },
    defaultTxtProductHighlights: {
      type: String,
      default: ''
    },
    defaultInfoModalHighlights: {
      type: String,
      default: ''
    },
    lblMoreInfoButton: {
      type: String,
      default: ''
    },
    areaLabelMoreInfo: {
      type: String,
      default: ''
    },
    lblOrderButton: {
      type: String,
      default: ''
    },
    txtLegalTerms: {
      type: String,
      default: ''
    },
    pricePromoColor: {
      type: String,
      default: ''
    },
    priceColor: {
      type: String,
      default: ''
    },
    txtPriceCurrency: {
      type: String,
      default: ''
    },
    txtInfoIconAlt: {
      type: String,
      default: ''
    },
    lblAriaLabelCTA: {
      type: String,
      default: ''
    }
  },
  methods: {
    addUpPromoVolumes (promos) {
      let volume = 0
      if (promos && promos.length > 0) {
        promos.forEach(promo => {
          if (promo.incentives) {
            promo.incentives.forEach(incentive => {
              volume += incentive.amount
            })
          }
        })
      }
      return volume
    },
    setAboOption (selected) {
      const option = this.findTarifOption([selected])
      this.$store.commit('checkoutv2/' + this.process + '/_cart/setSelectedTariffoptionIds', (selected !== 'none' && option[0] !== undefined) ? [option[0]?.tariffoptionId] : [])
    },
    prefillSelectedOption () {
      const params = new URLSearchParams(window.location.search)
      const optionParam = params.get('option')?.toLowerCase() || ''
      const preselectionURL = this.selectableAboOptions.find(e => e?.url?.toLowerCase() === optionParam)

      const option130 = this.preSelectOption130 && this.$store.getters['checkoutv2/' + this.process + '/_cart/preSelectedOption'] === '3035138'

      if (option130 || (this.preSelectOption130 && preselectionURL && preselectionURL.optionId === '3035138')) {
        this.isBestPriceSorted = false
        this.isOption130 = true
      }
      if (preselectionURL) {
        // set preselected option in store, for tracking
        this.$store.commit('checkoutv2/' + this.process + '/_cart/setPreSelectedOption', preselectionURL.optionId)
        params.delete('option')
        const newUrl = params.toString() ? `${location.pathname}?${params.toString()}` : location.pathname
        history.replaceState('', '', newUrl)
      }
    },
    getPromotionsForOption (optionIds) {
      return this.volumePromotions.filter(promo => {
        const promoOptionIds = promo.criteria?.tariffoptionIds || []
        return promoOptionIds.find(id => optionIds.includes(id))
      })
    }
  },
  computed: {
    ...mapGetters('checkout/tariff', [
      'findTarifOption',
      'defaultTariff'
    ]),
    ...mapGetters('promotion', ['presalesInclusivePromotion']),
    selectedAboOptionId: function () {
      const selectedTariffOptionIds = this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds'] // used in propositions
      return selectedTariffOptionIds.length > 0 ? selectedTariffOptionIds[0] : null
    },
    selectableAboOptions: function () {
      const today = new Date()
      today.setHours(0, 0, 0, 0) // Normalize today's date for comparison

      return this.availableAboOptions
        .filter(element => element.optionId === 'none' || this.findTarifOption([element.optionId]).length === 1)
        .map(option => {
          if (option.optionId === 'none') {
            option.promoVolume = this.basisPromoVolume
            option.basisVolume = this.basisVolume
            option.amount = option.basisVolume + option.promoVolume
            option.price = 0

            if (option.strikeAmount && parseInt(option.strikeAmount)) {
              option.basisVolume -= parseInt(option.strikeAmount)
            }

            return option
          }

          const tariffOption = this.findTarifOption([option.optionId])[0]
          const promos = this.getPromotionsForOption([option.optionId])
          let volume = 0
          let promoVolume = 0

          if (tariffOption?.volumes?.[0]?.amount > 0) {
            volume += tariffOption.volumes[0].amount
          }

          promoVolume = this.addUpPromoVolumes(promos)
          option.price = tariffOption?.price
          option.promoVolume = this.basisPromoVolume + promoVolume
          option.basisVolume = this.basisVolume + volume
          option.amount = option.basisVolume + option.promoVolume

          // wenn kuenstliches Streichvolumen im CMS gesetzt ist, dann wird es vom basisVolume abgezogen, um Streich-GB zu erzwingen
          if (option.strikeAmount && parseInt(option.strikeAmount)) {
            option.basisVolume -= parseInt(option.strikeAmount)
          }
          return option
        }).sort(this.isBestPriceSorted ? (a, b) => a.basisVolume - b.basisVolume : (a, b) => b.price - a.price)
    },
    selectableAboOptionKeys: function () {
      return this.selectableAboOptions.filter(option => option.optionId !== 'none').map(option => option.optionId)
    },
    basisVolume: function () {
      if (this.targetTariff && this.targetTariff.volumes && this.targetTariff.volumes[0]) {
        return this.targetTariff.volumes[0].amount || 20
      } else if (this.defaultTariff && this.defaultTariff.volumes && this.defaultTariff.volumes[0]) {
        return this.defaultTariff.volumes[0].amount || 20
      }
      return 20
    },
    basisPromoVolume: function () {
      const promos = this.volumePromotions.filter(promo => {
        const optionIds = promo.criteria?.tariffoptionIds || []
        return optionIds.length === 0
      })
      return this.addUpPromoVolumes(promos)
    },
    creditPromotions () { // only price promotions (permanent and temporary)
      return this.filteredPromotions.filter(promo => promo.incentives?.find(incentive => incentive.type === 'credit'))
    },
    filteredPromotions: function () {
      return this.targetPromotions.filter(promo => {
        // promotions that need e.g. voucher code are not displayed in tariff
        if (promo.requiredParameters !== null) return false

        // Tariff Filter -> only promotions that accept the current targetTariff
        if (this.targetTariff && this.targetTariff.tariffId !== null) {
          const tariffIds = promo.criteria?.tariffIds || []
          if (tariffIds.length > 0 && tariffIds.includes(this.targetTariff.tariffId) === false) return false
        }

        // Provider Filter -> only promotions that dont need a certain provider
        const criteriaMnpProvider = promo.criteria?.mnpProvider || []
        return criteriaMnpProvider.length === 0
      })
    }
  },
  watch: {}
}
</script>
